import { render, staticRenderFns } from "./AsociarFlotaEtiquetaVehiculo.vue?vue&type=template&id=45096702&"
import script from "./AsociarFlotaEtiquetaVehiculo.vue?vue&type=script&lang=ts&"
export * from "./AsociarFlotaEtiquetaVehiculo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports